import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_tipo_custo = _resolveComponent("selecionar-tipo-custo")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: 900,
      visible: _ctx.state.apresentarModal,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.apresentarModal) = $event)),
      "wrap-class-name": "ss-modal-cadastros",
      title: "Alteração de preço - Produto",
      maskClosable: false
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.apresentarModal = false))
          }, _hoisted_2),
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.salvarAlteracaoPreco && _ctx.salvarAlteracaoPreco(...args)))
          }, _hoisted_4)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_card, { titulo: " " }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_a_form_item, {
                      label: "Código Interno",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          readonly: "",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.produtoDefinicao.codigoInterno) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.produtoDefinicao.codigoInterno]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_a_form_item, {
                      label: "Descrição",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          readonly: "",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.produtoDefinicao.produto) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.produtoDefinicao.produto]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_form_item, {
                      label: "Unidade Principal",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          readonly: "",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.produtoDefinicao.unidade) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.produtoDefinicao.unidade]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.estruturas, (estrutura) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "ant-row",
                key: estrutura.codigoTipoPreco
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_card, {
                    titulo: _ctx.obterDescricaoTipoPreco(estrutura.codigoTipoPreco)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_a_form_item, {
                            label: "Baseado no",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_tipo_custo, {
                                codigoSelecionado: _ctx.state.produtoPrecos[_ctx.obtemIndexPrecoTabela(estrutura.codigoTipoPreco)].codigoTipoCusto,
                                "onUpdate:codigoSelecionado": ($event: any) => ((_ctx.state.produtoPrecos[_ctx.obtemIndexPrecoTabela(estrutura.codigoTipoPreco)].codigoTipoCusto) = $event),
                                empresas: _ctx.props.empresas,
                                limparSelecao: false
                              }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado", "empresas"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_a_form_item, {
                            label: "Markup",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                valor: _ctx.state.produtoPrecos[_ctx.obtemIndexPrecoTabela(estrutura.codigoTipoPreco)].markup,
                                "onUpdate:valor": ($event: any) => ((_ctx.state.produtoPrecos[_ctx.obtemIndexPrecoTabela(estrutura.codigoTipoPreco)].markup) = $event),
                                percentual: true
                              }, null, 8, ["valor", "onUpdate:valor"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_a_form_item, {
                            label: "Preço de venda",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                valor: _ctx.state.produtoPrecos[_ctx.obtemIndexPrecoTabela(estrutura.codigoTipoPreco)].valor,
                                "onUpdate:valor": ($event: any) => ((_ctx.state.produtoPrecos[_ctx.obtemIndexPrecoTabela(estrutura.codigoTipoPreco)].valor) = $event),
                                monetario: true,
                                quantidadeCasasDecimais: _ctx.obterQuantidadeCasasTipoPreco(estrutura.codigoTipoPreco)
                              }, null, 8, ["valor", "onUpdate:valor", "quantidadeCasasDecimais"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_a_form_item, {
                            label: "Desconto Máximo",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                valor: _ctx.state.produtoPrecos[_ctx.obtemIndexPrecoTabela(estrutura.codigoTipoPreco)].descontoMaximo,
                                "onUpdate:valor": ($event: any) => ((_ctx.state.produtoPrecos[_ctx.obtemIndexPrecoTabela(estrutura.codigoTipoPreco)].descontoMaximo) = $event),
                                percentual: true
                              }, null, 8, ["valor", "onUpdate:valor"])
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["titulo"])
                ])
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_requisicao_modal, {
      visivel: _ctx.modalBase.exibirRequisicaoModal,
      "onUpdate:visivel": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
      apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
      retornoRequisicao: _ctx.modalBase.retornoRequisicao
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
  ]))
}